import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseManageConsultants() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      top: isEmpty(state.top),
      start: isEmpty(state.start),
      end: isEmpty(state.end),
      productID: isEmpty(state.brandID) && isEmpty(state.productID),
      brandID: isEmpty(state.brandID) && isEmpty(state.productID),
    };
    setter(errorState);

    if (errorState.top || errorState.start || errorState.end) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (errorState.productID && errorState.brandID) {
      enqueueSnackbar("لطفا یا محصول یا برند را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetConsultants = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_ManageConsulate?w=${search}`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetConsultantById = (consultantId, callback) => {
    MyAxios.get(`Admin_ManageConsulate/${consultantId}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const findClients = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ManageConsulate/find`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };
  const clearConsultants = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ManageConsulate/clear`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddClients = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ManageConsulate`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validate,
    GetConsultants,
    GetConsultantById,
    findClients,
    AddClients,
    clearConsultants,
  };
}
